import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'RMS';
  companycode: string;
  url: string;
  isHTTPS: string = 'True';
  configdData: any;

  SetConfigData() {
    this.configdData = this.configService.getAppConfig();
    if (!this.configdData) {
      return;
    }

    this.url = this.router['location']._platformLocation.location.href;

    if (this.url.includes('https')) {
      this.isHTTPS = 'True';
      localStorage.setItem('isHTTPS', this.isHTTPS);
    } else {
      this.isHTTPS = 'False';
      localStorage.setItem('isHTTPS', this.isHTTPS);
    }

    this.url = this.url.replace('http://', '');
    this.url = this.url.replace('https://', '');
    var array = this.url.split('.');

    if (this.configdData['GetCompanyCodeFromURL'] == 'Y') {
      if (array && array.length > 2) {
        this.companycode = array[0];
        this.location.replaceState(this.location.path(false).replace('/home', '/login'));
      } else {
        var screenName = this.url.split('/')[1];

        if (screenName == 'flow-monitoring' || screenName == 'level-monitoring' || screenName == 'energymonitoring' || screenName == 'predictive-maintainance') {
        } else {
          this.router.navigate(['/home']);
        }
        this.location.replaceState(this.location.path(false).replace('/home', '/home'));
      }
    } else {
      this.companycode = this.configdData['CompanyCode'];
    }

    if (this.companycode) {
      localStorage.setItem('CompanyCode', this.companycode);
    }
  }

  constructor(
    private router: Router,
    private location: Location,
    private configService: ConfigurationsService
  ) {
    this.SetConfigData();
  }
}
